import { render, staticRenderFns } from "./ServiceOrdersDetails.vue?vue&type=template&id=763670df"
import script from "./ServiceOrdersDetails.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../physical-world-status.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2F_work%2Fdash-webapp%2Fdash-webapp%2Fsrc%2Fviews%2FPhysicalWorld%2FServiceOrders%2FServiceOrdersDetails.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./service-orders-filters.locale.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Frunner%2F_work%2Fdash-webapp%2Fdash-webapp%2Fsrc%2Fviews%2FPhysicalWorld%2FServiceOrders%2FServiceOrdersDetails.vue&external"
if (typeof block1 === 'function') block1(component)
import block2 from "./ServiceOrdersDetails.vue?vue&type=custom&index=2&blockType=i18n"
if (typeof block2 === 'function') block2(component)

export default component.exports